import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ChartBreakoutCircle = function ChartBreakoutCircle(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.5 3.5V2m3.9393 2.5607L20.5 3.5m.0103 5h1.5m-.0597 4.5c-.5017 5.0533-4.7653 9-9.9506 9-5.5228 0-10-4.4772-10-10 0-5.1853 3.9467-9.4489 9-9.9506M12 8h4v4m-.3803-4C13.2653 11.3276 9.3864 13.5 5 13.5a13.05 13.05 0 0 1-2.917-.3285"
    })
  }));
};
export default ChartBreakoutCircle;